module.exports = __webpack_public_path__ + "img/citadine_2.4715e6da.jpg";